import React from 'react'
import LogoLoader from '../../assets/logo-loader.gif';

export default function Loader(props) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '20px', minHeight: props.minHeight, width: props.containerWidth }}>
        <img src={LogoLoader} alt="loading" style={{ maxWidth: props.maxWidth }} />
      </div>
    )
  }